import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { delete_menu_image, fetch_menu_images, reorder_menu_images, upload_menu_image } from './api';

const KEY = ['menu-images'] as const;

export function use_menu_images() {
  return useQuery({ queryKey: KEY, queryFn: fetch_menu_images });
}

export function use_upload_menu_image() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (file: File) => upload_menu_image(file),
    onSuccess: (list) => qc.setQueryData(KEY, list),
  });
}

export function use_reorder_menu_images() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (ids: string[]) => reorder_menu_images(ids),
    onSuccess: (list) => qc.setQueryData(KEY, list),
  });
}

export function use_delete_menu_image() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => delete_menu_image(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY }),
  });
}
